// Business/legal constants shared by the landing, unsubscribe and legal pages.
export const SUPPORT_EMAIL = 'support@kid-security.io';
export const UNSUB_LINK = 'https://mega.kid-security.io/unsub';
export const SELFCARE_APP_NAME = 'Mega24';
export const CALL_CENTER_USSD = '*500';
export const MANAGE_USSD = '*5554*0#';
export const COMPANY_NAME = 'Strongbits';
export const COMPANY_LOCATION = 'Dubai, UAE';

// Used before /plans answers, or if the gateway can't be reached at all.
export const FALLBACK_PLANS = [
  { planId: 1, price: 6, freeDays: 3, renewalEveryDays: 1, validityDays: 1 },
  { planId: 2, price: 80, freeDays: 3, renewalEveryDays: 30, validityDays: 30 },
  { planId: 3, price: 800, freeDays: 3, renewalEveryDays: 365, validityDays: 365 },
];
